export default {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MAIN: '/main',
  LAUNCHER: '/launcher',
  DEBUG_LOGGER: '/debug-logger',
  TOUCH_PANEL: '/touchpanel',
  TRAINING_UNITS: '/main/units',
  SURFACE_COMBAT: '/main/combat',
  Window: `/window`,
  Catiz: `/catiz`,
  Catiz3: '/catiz3/main',
  CatizTouchPanel: '/catiz3/touchpanel',
  CatizTouchPanelWithLogin: '/catiz3/logintouchpanel',
  S80: '/s80',
  HERMESYS: '/hermesys',
  UPPER_MONITOR: '/s80/upper',
  LOWER_MONITOR: '/s80/lower',
  LESSON_CONTROLLER: '/lesson-controller',
  DESK: '/s80/desk',
  HERMESYS_MAIN: '/hermesys/main',
  HERMESYS_M3SR: '/hermesys/excomp/m3sr',
  HERMESYS_GX4100: '/hermesys/excomp/gx4100',
  HERMESYS_AVA20: '/hermesys/excomp/ava20',
  HERMESYS_TCT: '/hermesys/tct',
};
